import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { logTermAction } from './useTermsOfUseLogs';

interface PublishTermParams {
  termId: string;
  userId: string;
  userName: string;
}

export const usePublishTerm = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ termId, userId, userName }: PublishTermParams) => {
      // 1. Arquivar o termo ativo anterior (se existir)
      const { error: archiveError } = await supabase
        .from('terms_of_use')
        .update({ updated_at: new Date().toISOString() })
        .is('updated_at', null)
        .eq('pending_activation', false);
      
      if (archiveError) throw archiveError;
      
      // 2. Publicar o novo termo (definir pending_activation = false)
      const { error: publishError } = await supabase
        .from('terms_of_use')
        .update({ pending_activation: false })
        .eq('id', termId);
      
      if (publishError) throw publishError;
      
      // Registrar log de publicação
      await logTermAction({
        termId,
        action: 'publish',
        userId,
        userName
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['terms-of-use'] });
      // Invalidar todas as queries de term-acceptance (de todos os usuários)
      queryClient.invalidateQueries({ queryKey: ['term-acceptance'] });
      // Forçar refetch de todas as queries ativas
      queryClient.refetchQueries({ queryKey: ['term-acceptance'] });
      toast.success('Termo publicado e disparado com sucesso');
    },
    onError: (error) => {
      console.error('Erro ao publicar termo:', error);
      toast.error('Erro ao publicar o termo');
    }
  });
};

